var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import Header from "./components/AddHeader.vue";
import EQuotedPriceType from '../../enum/EQuotedPriceType';
import EHandleStatus, { EHanldeStatus } from '../../enum/EHandleStatus';
import AddDialog from "./components/GoodAdd.vue";
import { weekDefaultDate } from '../../helper/defaultDate';
import QuotedPrice from '../../api/QuotedPrice';
import GLOBAL_VUE from '../../globalVue';
import _ from 'lodash';
import { Loading } from 'element-ui';
import { auth } from "../../helper/authDecorator";
import { nameDict } from "../../constant/authCode";
import { UrlHelper } from '../../helper/UrlWrapper';
import { mapGetters } from 'vuex';
import SearchGoods from './components/SearchGoods';
import RequiredMixin from "../../components/renderHeader/RequiredMixin";
export var ESaveType;
(function (ESaveType) {
    ESaveType[ESaveType["Submit"] = 1] = "Submit";
    ESaveType[ESaveType["Save"] = 2] = "Save";
})(ESaveType || (ESaveType = {}));
var default_1 = (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tableHeight = document.documentElement.clientHeight - 280 - 60;
        _this.data = [];
        _this.searchPattern = false;
        _this.filterData = [];
        _this.formData = {
            order_code: [],
            client: [],
            fileListData: [],
            s_time: weekDefaultDate().Start,
            e_time: weekDefaultDate().End,
            order_icomment: "",
            clientArray: [],
            purchase_order_order_code: "",
            is_qi_must_upload_enclosure: 0
        };
        _this.enumType = EQuotedPriceType;
        _this.enumStatus = EHandleStatus;
        _this.handleStatus = EHandleStatus.Add;
        _this.ESaveType = ESaveType;
        _this.from_system = 3;
        _this.orderid = '';
        _this.total = 0;
        _this.searchParams = {
            goods_type_id: undefined,
            keyword: '',
        };
        _this.dialogTableVisible = false;
        _this.dialogTableEditVisible = false;
        _this.importSuccessNum = 0;
        _this.importFailnum = 0;
        _this.befordImport = true;
        _this.importting = false;
        _this.afterImport = false;
        _this.failDownLoadUrl = "";
        _this.responseSuccess = false;
        _this.responseFail = false;
        _this.errorMsg = "";
        _this.emptyMoneyCanSubmit = false;
        _this.notAllEmptyFlag = true;
        _this.emptyFlag = true;
        _this.goods_ids = [];
        _this.is_show_quotation_current_price = 1;
        _this.selectbusiness_ids = '';
        _this.select_supplier_to_business_ids = '';
        _this.expiry_start = '';
        _this.shop_id = '';
        return _this;
    }
    default_1.prototype.selectionChange = function (rows) {
        this.selections = rows;
    };
    default_1.prototype.toAdd = function () {
        var _this = this;
        if (!this.formData.clientArray || !this.formData.clientArray.length) {
            this.$message.warning("请选择客户");
            return;
        }
        var dialog = this.$dialog(AddDialog, {
            data: {
                added_goods_ids: this.goods_ids,
                addedDatas: this.data,
                purchasers: this.formData.clientArray
            }
        }, {
            title: "添加货品",
            width: 900,
            height: 550
        });
        dialog.instance.$on("submit", function (res) {
            _this.data = res;
            _this.selections = [];
            if (_this.handleStatus === EHanldeStatus.Edit) {
                _this.saveAjax(ESaveType.Save);
                window._czc.push(["_trackEvent", '常规报价添加货品', '添加货品', '添加货品']);
            }
        });
    };
    default_1.prototype.clearPrices = function () {
        var _this = this;
        this.$confirm('确认清空本次报价？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(function () {
            _this.data.forEach(function (item) {
                item.order_detail_money = '';
            });
        }).catch(function () {
        });
    };
    default_1.prototype.deleteGood = function () {
        var _this = this;
        if (!this.selections || !this.selections.length) {
            this.$message.warning("请选择货品");
            return;
        }
        if (this.handleStatus === EHanldeStatus.Edit && this.selections.length == this.goods_ids.length) {
            this.$message.warning("不支持删除所有货品");
            return;
        }
        this.$confirm("请确认是否删除该货品", '提示').then(function (res) {
            _this.selections.forEach(function (item) {
                var index = _this.data.indexOf(item);
                _this.data.splice(index, 1);
            });
            if (_this.handleStatus === EHanldeStatus.Add) {
                return;
            }
            var order_detail_id_list = _.uniqBy(_this.selections, "order_detail_id").map(function (item) { return item.order_detail_id; });
            var order_detail_ids = order_detail_id_list.join(',');
            var params = {
                order_id: _this.orderid,
                order_detail_ids: order_detail_ids
            };
            var loadingInstance = Loading.service({ fullscreen: true });
            _this.service.deleteOrderInfo(params).then(function (res) {
                _this.getDetail();
                _this.$message.success(res.data.msg);
                loadingInstance.close();
                window._czc.push(["_trackEvent", '常规报价添加货品', '删除货品', '删除货品']);
            }).catch(function (err) {
                _this.$message.error(err.msg || err.message);
                loadingInstance.close();
            });
        }, function (err) { });
    };
    default_1.prototype.orderChange = function () {
        var _this = this;
        if (this.priceType === EQuotedPriceType.Day &&
            this.formData.order_code.length &&
            this.handleStatus !== EHandleStatus.Edit) {
            var business_id = _.uniqBy(this.formData.clientArray, "business_id").map(function (item) { return item.business_id; });
            var supplier_to_business_id = _.uniqBy(this.formData.clientArray, "supplier_to_business_id").map(function (item) { return item.supplier_to_business_id; });
            var params = {
                business_id: business_id.join(","),
                supplier_to_business_ids: supplier_to_business_id.join(","),
                expiry_start: this.formData.s_time.format('yyyy-MM-dd'),
                shop_id: this.formData.order_code.join(",")
            };
            this.service.getDayGoodList(params).then(function (res) {
                _this.data = res.data.data;
            });
        }
    };
    default_1.prototype.clientChange = function (formData) {
        var _this = this;
        this.data = [];
        this.selections = [];
        if (!formData.client.length)
            this.is_show_quotation_current_price = 1;
        formData.clientArray = formData.client.map(function (item) {
            var is_show_quotation_current_price = item.split("&$")[3];
            console.log(item);
            if (is_show_quotation_current_price == 0)
                _this.is_show_quotation_current_price = 0;
            return {
                purchasing_agent_id: item.split("&$")[0],
                purchasing_agent: item.split("&$")[2],
                supplier_to_business_id: item.split("&$")[1],
                business_id: item.split("&$")[4],
            };
        });
    };
    default_1.prototype.save = function (save_type) {
        var _this = this;
        var formData = this.formData;
        if (!this.data || !this.data.length) {
            this.$message.warning("请添加货品");
            return;
        }
        if (this.formData.is_qi_must_upload_enclosure > 0 && this.formData.fileListData.length === 0) {
            this.$message.warning("请上传附件");
            return;
        }
        if (this.handleStatus === EHanldeStatus.Add) {
            if (!formData.clientArray || !formData.clientArray.length) {
                this.$message.warning("请选择商户");
                return;
            }
            if (save_type === ESaveType.Submit) {
                this.emptyFlag = this.data && this.data.some(function (item) {
                    return item.order_detail_money === '';
                });
                this.notAllEmptyFlag = this.data && this.data.some(function (item) {
                    return item.order_detail_money !== '';
                });
                if (!this.notAllEmptyFlag) {
                    this.$message.error("货品报价信息未填写完整，请补充！");
                    return;
                }
                if (this.emptyFlag && !this.emptyMoneyCanSubmit) {
                    this.$confirm('报价单存在报价为空的货品，请确认是否继续？', '提示', {
                        customClass: 'confirm'
                    }).then(function (res) {
                        if (res) {
                            _this.emptyMoneyCanSubmit = true;
                            _this.save(save_type);
                        }
                    }).catch(function (err) {
                        if (err) {
                            _this.emptyMoneyCanSubmit = false;
                        }
                    });
                    return;
                }
            }
            var rateFlag = this.data && this.data.some(function (item) {
                return item.reference_rate < 0;
            });
            if (rateFlag) {
                this.$message.error("参考税率不可为负值！");
                return;
            }
            var expiryStart = formData.s_time && formData.s_time.format("yyyy-MM-dd");
            var expiryEnd = formData.e_time && formData.e_time.format("yyyy-MM-dd");
            if (!expiryStart) {
                this.$message.error("开始时间不可为空！");
                return;
            }
            if (!expiryEnd) {
                this.$message.error("结束时间不可为空！");
                return;
            }
            var params = {
                business: JSON.stringify(formData.clientArray),
                save_type: save_type,
                order_type: this.priceType,
                shop_id: formData.order_code,
                expiry_start: expiryStart,
                expiry_end: expiryEnd,
                order_detail: JSON.stringify(this.data),
                order_icomment: formData.order_icomment,
                enclosures: JSON.stringify(formData.fileListData)
            };
            if (save_type === ESaveType.Submit) {
                params = _.extend(params, { null_quotation_alert: 0 });
            }
            var loadingInstance_1 = Loading.service({ fullscreen: true });
            this.service.create(params).then(function (res) {
                _this.$message.success(res.data.msg);
                setTimeout(function () {
                    GLOBAL_VUE.$emit("closeTab", _this);
                    if (_this.opener) {
                        _this.opener.getList();
                    }
                }, 500);
                if (_this.priceType === _this.enumType.Common) {
                    window._czc.push(["_trackEvent", '添加报价单', '添加常规报价单', '保存']);
                }
                if (_this.priceType === _this.enumType.Day) {
                    window._czc.push(["_trackEvent", '添加报价单', '添加日报价单', '保存']);
                }
            }).catch(function (err) {
                _this.$message.error(err.msg || err.message);
                loadingInstance_1.close();
            });
        }
        else {
            if (save_type === ESaveType.Submit) {
                this.emptyFlag = this.data && this.data.some(function (item) {
                    return item.order_detail_money === '';
                });
                this.notAllEmptyFlag = this.data && this.data.some(function (item) {
                    return item.order_detail_money !== '';
                });
                if (!this.notAllEmptyFlag) {
                    this.$message.error("货品报价信息未填写完整，请补充！");
                    return;
                }
                if (this.emptyFlag && !this.emptyMoneyCanSubmit) {
                    this.$confirm('报价单存在报价为空的货品，请确认是否继续？', '提示', {
                        customClass: 'confirm'
                    }).then(function (res) {
                        if (res) {
                            _this.emptyMoneyCanSubmit = true;
                            _this.save(save_type);
                        }
                    }).catch(function (err) {
                        if (err) {
                            _this.emptyMoneyCanSubmit = false;
                        }
                    });
                    return;
                }
            }
            var rateFlag = this.data && this.data.some(function (item) {
                return item.reference_rate < 0;
            });
            if (rateFlag) {
                this.$message.error("参考税率不可为负值！");
                return;
            }
            var params = {
                order_id: this.orderid,
                save_type: save_type,
                order_detail: JSON.stringify(this.data),
                order_icomment: formData.order_icomment,
                enclosures: JSON.stringify(formData.fileListData)
            };
            if (save_type === ESaveType.Submit) {
                params = _.extend(params, { null_quotation_alert: 0 });
            }
            var loadingInstance_2 = Loading.service({ fullscreen: true });
            this.service.editSave(params).then(function (res) {
                _this.$message.success(res.data.msg);
                setTimeout(function () {
                    GLOBAL_VUE.$emit("closeTab", _this);
                    if (_this.opener) {
                        _this.opener.getList();
                    }
                    loadingInstance_2.close();
                }, 500);
            }).catch(function (err) {
                loadingInstance_2.close();
                _this.$message.error(err.msg || err.message);
            });
        }
    };
    default_1.prototype.editPrices = function () {
        this.dialogTableEditVisible = true;
    };
    default_1.prototype.exportTable = function () {
        var url = 'supplierclientapi/quotationorder/export_edit?order_id=' + this.orderid;
        url = UrlHelper.addParam(url, 'token', this.user.token);
        location.href = url;
        window._czc.push(["_trackEvent", '报价单导出', '报价单导出']);
    };
    default_1.prototype.importFile = function () {
        var formData = this.formData;
        if (!formData.clientArray || !formData.clientArray.length) {
            this.$message.warning("请选择商户");
            return;
        }
        if (this.priceType == this.enumType.Day && (!formData.order_code || !formData.order_code.length)) {
            this.$message.warning("请选择关联订单");
            return;
        }
        this.dialogTableVisible = true;
        var selectid = Array.from(new Set(this.formData.clientArray.map(function (item) { return item.business_id; }))).join(',');
        var supplier_to_business_ids = Array.from(new Set(this.formData.clientArray.map(function (item) { return item.supplier_to_business_id; }))).join(',');
        this.selectbusiness_ids = selectid;
        this.select_supplier_to_business_ids = supplier_to_business_ids;
        this.expiry_start = this.formData.s_time.format('yyyy-MM-dd');
        this.shop_id = this.formData.order_code.join(",");
        this.setUploadType("beford");
    };
    default_1.prototype.mounted = function () {
        if (this.orderid) {
            this.getDetail();
        }
    };
    default_1.prototype.created = function () {
        this.service = QuotedPrice.getInstance();
    };
    default_1.prototype.pageChange = function (pager) {
        if (this.handleStatus === EHanldeStatus.Edit) {
            this.getDetail();
        }
    };
    default_1.prototype.getDetail = function () {
        var _this = this;
        var pager = this.$refs.pagination.getPage();
        this.handleStatus = EHandleStatus.Edit;
        var loadingInstance = Loading.service({ fullscreen: true });
        var params = {
            order_id: this.orderid,
            goods_type_id: this.searchParams.goods_type_id,
            keyword: this.searchParams.keyword,
        };
        Object.assign(params, { start: pager.start, limit: pager.limit });
        this.service.getDetail(params).then(function (res) {
            loadingInstance.close();
            var data = res.data.data;
            _this.is_show_quotation_current_price = data.is_show_quotation_current_price;
            if ((params.goods_type_id || params.keyword) && JSON.stringify(data) === '[]') {
                _this.data = [];
                _this.total = 0;
            }
            else {
                _this.from_system = data.from_system;
                _this.formData.s_time = data.expiry_start.toDate();
                if (data.expiry_end) {
                    _this.formData.e_time = data.expiry_end.toDate();
                }
                _this.formData.order_icomment = data.order_icomment;
                _this.formData.business = data.business;
                _this.formData.fileListData = data.enclosures;
                _this.formData.is_qi_must_upload_enclosure = data.is_qi_must_upload_enclosure;
                _this.formData.clientArray = [{
                        business_id: data.business_id,
                        supplier_to_business_id: data.supplier_to_business_id,
                    }];
                _this.formData.order_code = data.shop_ids;
                _this.formData.purchase_order_order_code = data.purchase_order_order_codes;
                _this.priceType = data.order_type;
                _this.data = (data.order_detail || []).map(function (item) {
                    if (!!_this.is_show_quotation_current_price && !item.order_detail_money) {
                        item.order_detail_money = item.current_uprice;
                    }
                    return item;
                });
                _this.total = res.data.total || 0;
                _this.goods_ids = data.goods_ids || [];
            }
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message || err.msg);
        });
    };
    default_1.prototype.befordUpload = function (file) {
        var name = file.name.split("."), fileType = name[name.length - 1];
        if (fileType == "xlsx" || fileType == "xls") {
            if (!this.loadingInstance)
                this.loadingInstance = Loading.service({ fullscreen: true });
            return;
        }
        this.$message.error("文件只能是xlsx或xls");
        return false;
    };
    default_1.prototype.uploadSuccess = function (response, file, fileList) {
        var _this = this;
        if (response.success) {
            this.responseSuccess = true;
            var data = response.data;
            this.importSuccessNum = data.success_num;
            this.importFailnum = data.error_num;
            var url = '';
            if (this.dialogTableEditVisible) {
                this.getDetail();
                url = "/basicapi/export_error?import_id=" + data.import_id + "&type=" + data.type;
                window._czc.push(["_trackEvent", '编辑报价单', '批量改价', '批量改价']);
            }
            else {
                url = "/basicapi/export_error?import_id=" + data.import_id + "&type=" + data.type;
                var goodsListMap_1 = Object.fromEntries(data.goods_list.map(function (item) { return [item.business_goods_id, item]; }));
                this.data = this.data.map(function (item) {
                    if (goodsListMap_1.hasOwnProperty(item.business_goods_id)) {
                        var newData = goodsListMap_1[item.business_goods_id];
                        return __assign({}, item, { order_detail_money: newData.order_detail_money });
                    }
                    return item;
                });
                data.goods_list.forEach(function (item) {
                    if (!_this.data.some(function (existingItem) { return existingItem.business_goods_id === item.business_goods_id; })) {
                        _this.data.push(item);
                    }
                });
                if (this.handleStatus === EHanldeStatus.Edit && data.goods_list && data.goods_list.length) {
                    this.saveAjax(ESaveType.Save);
                }
                window._czc.push(["_trackEvent", '常规报价添加货品', '导入货品', '导入货品']);
            }
            url = UrlHelper.addParam(url, 'token', this.user.token);
            this.failDownLoadUrl = url;
        }
        else {
            this.responseFail = true;
            this.errorMsg = response.msg || "网络异常，请重新导入";
            this.$message.error(response.msg);
        }
        this.uploadEnd(response);
    };
    default_1.prototype.saveSingle = function (row) {
        var _this = this;
        if (this.handleStatus === EHanldeStatus.Add) {
            return;
        }
        var params = {
            order_id: this.orderid,
            save_type: ESaveType.Save,
            order_detail: JSON.stringify([row]),
            order_icomment: this.formData.order_icomment
        };
        this.service.editSave(params).then(function (res) {
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
    };
    default_1.prototype.saveAjax = function (save_type) {
        var _this = this;
        var params = {
            order_id: this.orderid,
            save_type: save_type,
            order_detail: JSON.stringify(this.data),
            order_icomment: this.formData.order_icomment
        };
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.editSave(params).then(function (res) {
            _this.getDetail();
            loadingInstance.close();
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
            loadingInstance.close();
        });
    };
    default_1.prototype.uploadError = function (err, file, fileList) {
        this.responseFail = true;
        this.errorMsg = err.msg || err.message || "网络异常，请重新导入";
        this.uploadEnd();
    };
    default_1.prototype.uploadEnd = function (res) {
        if (!res.success && res.code && res.code == 9999) {
            this.responseFail = false;
            this.errorMsg = "";
            this.setUploadType("beford");
        }
        else {
            this.setUploadType("after");
        }
        this.loadingInstance.close();
    };
    default_1.prototype.uploadProgress = function (event, file, fileList) {
        this.setUploadType("importing");
    };
    default_1.prototype.setUploadType = function (type) {
        this.befordImport = type == 'beford';
        this.importting = type == 'importing';
        this.afterImport = type == 'after';
    };
    default_1.prototype.search = function (searchParams) {
        var _this = this;
        this.searchParams = searchParams;
        if (this.handleStatus === EHanldeStatus.Edit) {
            this.$refs.pagination.clear();
            this.getDetail();
            window._czc.push(["_trackEvent", '编辑报价单', '货品搜索', '货品搜索']);
        }
        else {
            if (this.searchParams.goods_type_id || this.searchParams.keyword) {
                var goodsTypeIds_1 = [];
                var goods_type_id_1 = this.searchParams.goods_type_id;
                var goodsTypeSelectNode = searchParams.goods_type_select_node;
                if (goods_type_id_1) {
                    goodsTypeIds_1.push(goods_type_id_1);
                    if (goodsTypeSelectNode && goodsTypeSelectNode.children && goodsTypeSelectNode.children.length) {
                        goodsTypeSelectNode.children.forEach(function (v) {
                            goodsTypeIds_1.push(v.goods_type_id);
                        });
                    }
                }
                var keyword_1 = this.searchParams.keyword;
                var filterData_1 = [];
                this.data.forEach(function (v) {
                    if ((!_this.searchParams.keyword || (_this.searchParams.keyword && (v.business_goods_name.indexOf(keyword_1) > -1 || v.business_goods_code.indexOf(keyword_1) > -1 || v.supplier_goods_name.indexOf(keyword_1) > -1)))
                        && (!goods_type_id_1 || (goods_type_id_1 && goodsTypeIds_1.indexOf(v.goods_type_id) > -1))) {
                        filterData_1.push(v);
                    }
                });
                this.filterData = filterData_1;
                this.searchPattern = true;
            }
            else {
                this.searchPattern = false;
            }
            window._czc.push(["_trackEvent", '添加报价单', '货品搜索', '货品搜索']);
        }
    };
    default_1 = __decorate([
        auth(nameDict["报价"], true),
        Component({
            mixins: [RequiredMixin],
            components: {
                'add-header': Header,
                SearchGoods: SearchGoods
            },
            computed: __assign({}, mapGetters({
                "user": "user"
            }))
        })
    ], default_1);
    return default_1;
}(Vue));
export default default_1;
